import { render, staticRenderFns } from "./TagShow.vue?vue&type=template&id=65d7fb5c"
import script from "./TagShow.vue?vue&type=script&lang=js"
export * from "./TagShow.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports